import React, { useEffect } from "react";

import {
  Heading,
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material"; 

import Aos from "aos";
import "aos/dist/aos.css";
const Background = styled.div`
  background-color: black;
  padding: 59px 0px;
  // background: url("/images/bg.png");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: cover;
  // min-height: 100vh;
  // display: flex;
  // align-items: center;
  // @media screen and (max-width: 899px) {
  //   padding: 100px 0 0 0;
  // }
`;

const Intro = styled(Grid)`
  padding: 25px 0px;
  // height: 100vh;
  display: flex;
  border: 1px solid black;
  @media screen and (max-width: 899px) {
    // padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const IntroImage = styled(Grid)`
  padding: 50px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const Div = styled.div`
  text-align: left;
`;
const AboutImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 500px;
`;


const S3_About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <div id="aboutus">
      <Background>
        <Container maxWidth="xl">
          <Grid container style={{ textAlign: "center" }}>
            <Intro
              xs={12}
              md={6}
              p599="30px 0 0 0"
              align="center"
              style={{ paddingTop: "90px" }}
            >
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <AboutImage
                  src="/images/S3-image.png" 
                />
              </Div>
            </Intro>

            <Intro xs={12} md={6} p599="30px 0 0 0" align="center">
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <SectionHeading style={{ textAlign: "left" }}>
                  What&apos;s All This About{" "}
                </SectionHeading>
                <P maxWidth="80%" p="0px 0px 30px 0" align="left">
                  Proof of ape is a gasless blockchain that is launching one of
                  the fastest and most efficient blockchains known to apes. We
                  will be releasing the first ever Dex called DegenApeSwap with
                  the lowest fees on ETH.
                  <br />
                  <br />
                  Soon all apes of defi will be able to create their own smart
                  contracts and ape into projects on our blockchain.
                </P>
              </Div>
            </Intro>
          </Grid>
        </Container>
      </Background>
    </div>
  );
};

export default S3_About;
